<template>
  <div class="registry-page">
    <navbar :isApp="isApp"></navbar>
    <navtool :fromTo='4' ></navtool>
    <div class="registry-head">
      <div class="strategy-list">
        <div class="strategy-list-info">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(strategy,$index) in strategyList" :key="$index">
                <div 
                  class="swiper-slide-info action_post_web_data"
                  :data-action="`{'actionName':'registry_strategy'}`"
                  @click="goUrl(isApp?strategy.app_link:strategy.wap_link)"
                >
                  <div class="strategy-text-blank">
                    <div class="strategy-text-title">{{strategy.title}}</div>
                    <div class="strategy-text-summary-vertical"><div class="strategy-text-summary">{{strategy.desc}}</div></div>
                  </div>
                  <div class="strategy-btn-blank">
                    <img class="strategy-btn-img" src="../../../assets/registry/goStrategy.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="strategy-list-footer-bg"></div>
        <div
          class="strategy-list-footer-btn action_post_web_data"
          :data-action="`{'actionName':'registry_guide'}`"
          @click="goAllStrategy"
        >全部指南</div>
      </div>
    </div>
    <div class="city-line">
      <div
        class="selected-city action_post_web_data"
        :data-action="`{'actionName':'registry_city'}`"
        @click="goCity"
      >
        <img class="selected-city-img" src="../../../assets/registry/cityLocation.png" />
        <div class="selected-city-text">{{selectedCity}}</div>
      </div>
      <div
        class="all-city action_post_web_data"
        :data-action="`{'actionName':'registry_city'}`"
        @click="goCity"
      >切换城市</div>
    </div>
    <div class="registry-list">
      <div class="registry-info" v-for="(registry,$index) in registryList" :key="$index">
        <div class="registry-info-title">{{registry.registryName}}</div>
        <div class="registry-info-details">
          <div class="registry-info-details-addr">{{registry.registryAddress?registry.registryAddress:'详细地址请戳导航'}}</div>
          <div class="registry-info-details-workday">
            <div class="registry-info-details-icon">
              <img class="registry-info-details-img" src="../../../assets/registry/timeIcon.png" />
            </div>
            <div class="registry-info-details-text">
              {{registry.registryServiceInfo1}}
              <br />
              {{registry.registryServiceInfo2}}
            </div>
            <div class="registry-info-details-time" v-if="registry.registryServiceInfo3">
              {{registry.registryServiceInfo3}}
            </div>
          </div>
          <div class="registry-info-details-contact">
            <div class="registry-info-details-icon">
              <img class="registry-info-details-img" src="../../../assets/registry/phoneIcon.png" />
            </div>
            <div class="registry-info-details-text">{{registry.registryTel?registry.registryTel:'暂无电话信息'}}</div>
          </div>
        </div>
        <div class="registry-info-btn">
          <a
            v-if="registry.registryTel"
            v-bind:class="{ 'registry-info-btn-call': false, 'registry-info-btn-map': true, 'registry-a-call': true, 'action_post_web_data':true }"
            :data-action="`{'actionName':'registry_phone'}`"
            :href="'tel:' + registry.registryTel"
          >
            <img class="registry-info-btn-img" src="../../../assets/registry/phone.png" />
            <div class="registry-info-btn-text">电话</div>
          </a>
          <div
            v-if="false"
            class="registry-info-btn-map action_post_web_data"
            :data-action="`{'actionName':'registry_navigate'}`"
            @click="goMap(registry.registryName)"
          >
            <img class="registry-info-btn-img" src="../../../assets/registry/mapNav.png" />
            <div class="registry-info-btn-text">导航</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-content" v-if="!registryList || registryList.length < 1">
      <img class="no-content-img" src="../../../assets/registry/nationalIcon.png" />
      <div class="no-content-text">该页面还未添加信息</div>
    </div>
    <div class="registry-feedback" v-if="isGreater">
      <div class="registry-feedback-btn" @click="goUrl('ciw://feedback')">地址，电话等信息报错</div>
    </div>
    <!-- 底部拨号 -->
    <!-- <div v-if="telShow" class="tel-phone-bg"></div>
    <div v-if="telShow" class="tel-phone">
      <a class="tel-phone-play" :href="'tel:' + telPlone">{{telPlone}}</a>
      <div class="tel-phone-clear" @click="closeTel">取消</div>
    </div> -->
    <!-- 信息提示弹窗 -->
    <div v-if="popShow" class="strategy-message-pop">{{popMessage}}</div>
  </div>
</template>
<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import browers from '../../../../plugins/browser.js'
import AppCall from '../../preview/appcall/utils/appcall.js'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Navbar from '../../../components/navbar/app.vue'
import Navtool from '../../../components/navtool/app.vue'
import callapp from 'callapp'

export default {
  components:{
    Navbar,
    Navtool
  },
  data() {
    return {
      isCanClick: true,
      popShow: false,
      popMessage: '',
      isLoading: true,
      isLogin: true,
      isIPhoneX: false,
      isApp: false,
      isWeiXin: false,
      selectedCity: '', // 已选择城市名称
      selectedCityId: 0, // 已选择城市ID
      fontSize: 0,
      showTool: true, //显示工具导航
      touching: false, // 代表当前是否处于 下拉刷新行为的开关
      startY: 0, // 保存 滑动y轴点的位置
      cityId: '', //app携带cityId
      token: '',
      areaCode: '', //选择城市区域
      registryList: [], //结婚登记处列表
      strategyList: [], //攻略指南列表
      strategyListNum: 6, //攻略指南显示数量
      huatiId: '', //话题id
      telShow: false, //拨打电话
      telPlone: '', //登记电话号码
      isGreater: GLOBAL.compareAppVersion('6.23.0').isGreater //是否高于版本号
    }
  },
  mounted() {
    var that = this
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    // 设置标题
    document.title = '结婚登记处'
    AppCall.callapp('ui_webview_title', { title: '结婚登记处' }, '')
    //判断是否为iphonex
    GLOBAL.setIPhoneX()
    that.isIPhoneX = GLOBAL.isIPhoneX
    // 获取token和城市ID
    that.getTokenAndCity()
    // 判断是否为app内
    that.isApp = browers().isApp
    // 判断是否为微信内
    that.isWeiXin = GLOBAL.isWeiXin()
    //初始化数据
    that.getHomeInfo()

    //计算设配fontSize 用于计算滚动条滚动距离
    var fontSize = GLOBAL.setPhoneRem()
    fontSize = fontSize.substring(0, fontSize.length - 2)
    that.fontSize = fontSize
    //数据上报
    window.$action = new postdata({ 
      appkey: 'hunbasha_wap',
      pageName:location.pathname,
      sensor_option:{
        openAll:true
      }
    })
  },
  methods: {
    /**
     * 获取所有城市列表
     */
    getAllCity() {
      var that = this
      if (!sessionStorage.getItem('listAllCity')) {
        // 后台API请求参数
        let requestData = {}
        //获取城市列表信息
        axios
          .post(
            GLOBAL.getUrlDomainForRegistry() + 'list-all-city',
            requestData,
            {
              headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'city-id': that.cityId,
                Authorization: that.token
              }
            }
          )
          .then(function(result) {
            var code = result.data.code
            // 成功
            if (code === 0) {
              sessionStorage.setItem(
                'listAllCity',
                JSON.stringify(result.data.data)
              )
              that.setCityInfo()
            } else if (code === -1) {
              that.setData({
                // 设置未登录信息
                cityMessage: result.data.message,
                // 显示未登录信息弹窗
                cityPopShow: true
              })
              // 1秒后自动关闭收藏信息提示弹窗
              setTimeout(that.closePop, 1000)
              // console.log(result.data.message)
            }
          })
      } else {
        that.setCityInfo()
      }
    },
    /**
     * 对城市数据解析
     */
    setCityInfo() {
      var that = this
      var citydata = JSON.parse(sessionStorage.getItem('listAllCity'))
      // 已开通的所有城市列表
      var cityList = citydata.allCityList
      // 设置浏览城市信息
      for (var i = 0; i < cityList.length; i++) {
        if (
          sessionStorage.getItem('registryAreaCode') == cityList[i].citySiteId
        ) {
          that.selectedCity = cityList[i].sysAreasDto.cityName // 已选择城市名称
          that.selectedCityId = cityList[i].citySiteId
        }
      }
    },
    /**
     * 获取登记处列表信息
     */
    getHomeInfo() {
      var that = this
      let requestData = that.areaCode ? { areaCode: that.areaCode } : {}
      axios
        .post(GLOBAL.getUrlDomainForRegistry() + 'get-home-info', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(function(result) {
          var code = result.data.code
          var data = result.data.data
          // console.log(result)
          if (code == 0) {
            sessionStorage.setItem('registryAreaCode', data.areaCode)
            that.huatiId = data.registryHuatiId
            that.getStrategyList()
            if (data.registryList) {
              that.registryList = data.registryList
            } else {
              location.replace('national.html')
            }
            that.getAllCity() //获取城市列表 设置当前城市
          } else if (code === -1) {
            that.popMessage = result.data.message
            that.popShow = true
            // 1秒后自动关闭收藏信息提示弹窗
            setTimeout(that.closePop, 1000)
            // console.log(result.data.message)
          }
        })
    },
    /**
     * 获取攻略列表信息
     */
    getStrategyList() {
      var that = this
      let requestData = {
        huati_id: that.huatiId,
        data_type: 1,
        pageSize: that.strategyListNum
      }
      axios
        .post(
          GLOBAL.getBaseUrlDomain() + 'zone/huati/get-relates',
          requestData,
          {
            headers: {
              'Content-Type': 'application/json;charset=utf-8'
            }
          }
        )
        .then(function(result) {
          // console.log(result)
          if (result.data.code == 0) {
            that.strategyList = result.data.data.lists
            //加载swiper
            that.$nextTick(function() {
              new Swiper('.swiper-container', {
                direction: 'vertical' /*垂直滑动*/,
                loop: true, //首尾衔接
                slidesPerView: 3, //显示slides数量
                autoplay: {
                  //自动
                  disableOnInteraction: false //操作后继续轮播
                }
              })
            })
          } else {
            that.popMessage = result.data.message
            that.popShow = true
            // 1秒后自动关闭收藏信息提示弹窗
            setTimeout(that.closePop, 1000)
            // console.log(result.data.message)
          }
        })
    },
    /**
     * 跳转地图导航
     */
    goMap(addr) {
      var that = this
      location.assign('map.html?registryAddress=' + encodeURI(encodeURI(addr)) + '&cityAddress' + encodeURI(encodeURI(that.selectedCity)))
    },
    /**
     * 跳转url
     */
    goUrl(url) {
      location.assign(url)
    },
    /**
     * 跳转全部指南
     */
    goAllStrategy(){
      var url = GLOBAL.getIndexPage() + '/huati/'+this.huatiId+'/'
      location.assign(url)
    },
    goCity() {
      location.assign('city.html?beFromPage=1')
    },
    /**
     * 显示拨号弹窗
     */
    openTel(phone) {
      var that = this
      that.telShow = true
      that.telPlone = phone
    },
    closeTel() {
      var that = this
      that.telShow = false
      that.telPlone = ''
    },
    /**
     * 关闭信息提示弹窗
     */
    closePop() {
      var that = this
      that.popShow = false
      that.popMessage = ''
    },
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID从任务index读取
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
      //areaCode
      that.areaCode = sessionStorage.getItem('registryAreaCode')
    },
  }
}
</script>

<style>
body {
  margin: 0 !important;
}
.registry-page {
  width: 100%;
  min-height: 100vh;
  font-family: PingFangSC-Medium;
  background: rgba(245, 248, 250, 1);
  background-repeat: no-repeat;
}
.registry-head {
  background: linear-gradient(
    270deg,
    rgba(255, 85, 66, 1) 0%,
    rgba(255, 59, 80, 1) 100%
  );
  background-repeat: no-repeat;
  width: 37.5rem;
}
.city-line {
  width: 100%;
  height: 4rem;
  background: rgba(255, 255, 255, 1);
  border-bottom: 0.05rem solid rgba(238, 238, 238, 1);
}
.selected-city {
  display: flex;
  height: 2rem;
  margin-top: 1rem;
  margin-left: 2rem;
  float: left;
}
.selected-city-img {
  width: 2rem;
  height: 2rem;
}
.selected-city-text {
  height: 2rem;
  height: 2rem;
  font-size: 1.3rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-left: 0.5rem;
}
.all-city {
  display: flex;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.3rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(255, 59, 80, 1);
  margin-top: 1rem;
  margin-right: 2rem;
  float: right;
}
.strategy-list {
  width: 37.5rem;
  height: 25.65rem;
  padding-top: 0.85rem;
  position: relative;
}
.strategy-list-info {
  width: 33.5rem;
  height: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  /* box-shadow:0 -0.1rem 1rem 0 rgba(115,0,0,0.15); */
  border-radius: 1.2rem;
  position: relative;
}
.strategy-list-footer-bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4.1rem;
  background: radial-gradient(
    37.5rem 2.3rem at center top,
    rgba(17, 32, 43, 0) 50%,
    rgba(245, 248, 250, 1) 50%
  );
  /* box-shadow: 0 0.4rem 0.5rem 0 rgba(126,0,13,0.07); */
  z-index: 5;
}
.strategy-list-footer-btn {
  position: absolute;
  left: 13.75rem;
  bottom: 1rem;
  width: 10rem;
  height: 2.5rem;
  padding-top: 0.5rem;
  background: linear-gradient(
    270deg,
    rgba(255, 85, 66, 1) 0%,
    rgba(255, 59, 80, 1) 100%
  );
  box-shadow: 0 0.1rem 0.5rem 0 rgba(255, 59, 80, 0.4);
  border-radius: 1.5rem;
  text-align: center;
  font-size: 1.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  z-index: 9;
}
.swiper-container {
  width: 31.2rem;
  height: 24.3rem;
  overflow: hidden;
  position: absolute;
  top: 0.75rem;
  left: 1.1rem;
}
.swiper-wrapper {
  width: 31.2rem;
  height: 16rem;
}
.swiper-slide {
  width: 31.2rem;
  height: 8.1rem !important;
}
.swiper-slide-info {
  width: 30.6rem;
  height: 7.1rem;
  background: rgba(255, 247, 247, 1);
  border-radius: 0.4rem;
  border: 0.3rem solid rgba(255, 230, 229, 1);
  margin-bottom: 0.4rem;
  overflow: hidden;
}
.strategy-text-blank {
  height: 5.7rem;
  width: 26.2rem;
  margin-top: 0.7rem;
  margin-left: 0.7rem;
  float: left;
}
.strategy-text-title {
  width: 26.2rem;
  height: 2rem;
  font-size: 1.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.strategy-text-summary-vertical {
  width: 26.2rem;
  height: 3.3rem;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
}
.strategy-text-summary {
  width: 26.2rem;
  max-height: 3.3rem;
  font-size: 1.2rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 1.65rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.strategy-btn-blank {
  height: 1.2rem;
  width: 1.2rem;
  padding: 2.95rem 1.5rem 2.95rem 0.85rem;
  float: right;
}
.strategy-btn-img {
  width: 1.2rem;
  height: 1.2rem;
}
.registry-list {
  width: 100%;
}
.registry-info {
  width: 33.5rem;
  /* height: 15.3rem; */
  background: rgba(255, 255, 255, 1);
  border-radius: 0.05rem;
  margin-top: 0.5rem;
  padding: 0 2rem;
}
.registry-info:first-of-type {
  margin-top: 0;
}
.registry-info-title {
  width: 33.5rem;
  height: 2.5rem;
  font-size: 1.6rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 2.5rem;
  padding-top: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.registry-info-details {
  width: 25.2rem;
  /* float: left; */
  display: inline-block;
}
.registry-info-details-addr {
  width: 100%;
  height: 1.85rem;
  font-size: 1.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 1.85rem;
  margin-top: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.registry-info-details-workday {
  width: 100%;
  min-height: 3.7rem;
  margin-top: 1.2rem;
}
.registry-info-details-icon {
  width: 2rem;
  height: 1.85rem;
  float: left;
}
.registry-info-details-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.2rem;
}
.registry-info-details-text {
  width: 23.2rem;
  font-size: 1.3rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 1.85rem;
  /* float: left; */
  margin-left: 2rem;
  white-space: nowrap;
}
.registry-info-details-time {
  width: 23.2rem;
  font-size: 1.1rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(122, 122, 122, 1);
  line-height: 1.5rem;
  /* float: left; */
  margin-left: 2rem;
  margin-top: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.registry-info-details-contact {
  margin-top: 0.6rem;
  margin-bottom: 1.65rem;
  height: 1.85rem;
}
.registry-info-btn {
  width: 7.6rem;
  margin-top: 1.65rem;
  float: right;
}
.registry-a-call{
  display: block;
  text-decoration: none;
}
.registry-info-btn-call {
  width: 2.8rem;
  float: left;
}
.registry-info-btn-map {
  width: 2.8rem;
  float: right;
}
.registry-info-btn-img {
  width: 2.8rem;
  height: 2.8rem;
}
.registry-info-btn-text {
  width: 2.8rem;
  height: 1.65rem;
  font-size: 1.2rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 1.65rem;
  text-align: center;
}
.registry-feedback {
  width: 23.5rem;
  height: 4rem;
  padding: 2rem 7rem 3rem 7rem;
}
.registry-feedback-btn {
  width: 23.5rem;
  height: 4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.4rem;
  font-size: 1.5rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(255, 59, 80, 1);
  line-height: 4rem;
  text-align: center;
}
.tel-phone-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(34, 34, 34, 1);
  opacity: 0.9;
  z-index: 19;
}
.tel-phone {
  width: 33.5rem;
  position: fixed;
  bottom: 3rem;
  left: 2rem;
  opacity: 0.9;
  z-index: 20;
}
.tel-phone-play {
  width: 100%;
  height: 3rem;
  display: block;
  padding: 1rem 0;
  height: 2rem;
  font-size: 1.2rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  background: rgba(255, 255, 255, 1);
  line-height: 2rem;
  text-align: center;
  text-decoration: none;
  color: #3987d7;
  border-radius: 0.3rem;
}
.tel-phone-clear {
  width: 100%;
  margin-top: 1rem;
  padding: 1rem 0;
  height: 2rem;
  font-size: 1.2rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  background: rgba(255, 255, 255, 1);
  line-height: 2rem;
  text-align: center;
  color: rgba(255, 59, 80, 1);
  border-radius: 0.3rem;
}
.strategy-message-pop {
  width: 20.5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.6rem;
  position: fixed;
  top: 21.5rem;
  left: 8.5rem;
  background-color: #333333;
  opacity: 0.9;
  z-index: 999;
}
.no-content {
  width: 100%;
}
.no-content-img {
  width: 8rem;
  height: 8rem;
  margin-top: 8rem;
  margin-left: 14.75rem;
}
.no-content-text {
  width: 100%;
  height: 2.1rem;
  font-size: 1.5rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 2.1rem;
  margin-top: 1.6rem;
  text-align: center;
}
</style>
